<template>
  <v-layout justify-center>
    <v-flex>

      <v-container grid-list-md>
        <v-layout row wrap>
          <v-flex xs12 class="text-xs-center">
            <h1>
              <b>{{ display_text }} Form</b>
            </h1>
          </v-flex>
        </v-layout>


        <v-layout row wrap v-if="show_form" style="background-color: white;">
          <v-flex xs12 sm12 md1 lg2></v-flex>
          <v-flex xs12 sm12 md10 lg8>
              <iframe
                id="frm_window"
                frameborder="0"
                :src="selected.iframe.url"
                width="100%"
                :height="selected.iframe.height"
              ></iframe>
          </v-flex>
          <v-flex xs12 sm12 md1 lg2></v-flex>
        </v-layout>
      </v-container>
      
    </v-flex>
  </v-layout>
</template>

<script>
// import axios from "axios";
import auth from "../../functions/auth";
import common from "../../functions/general";
import comm from "../../functions/communication.api";
import qb from "../../functions/query.builder";

export default {
	name: "Survey",
  // components: {
  //   PageLayout: PageLayout
  // },
  data() {
    return {
      username: "",
			name: "",
      form_id: "",
      addNew_path: "",
      display_text: "",
      return_page: "",
      hub: "",
      department: "",
			// hrm_page_id: 78, // ensure corret setting
      // years: [],
      // quarters: [],
      url:"",
      show_form: false,
      selected: {
        // year: "",
        // quarter: "",
        iframe: {
          url: "",
          height: ""
        }
      }
    };
  },
  created (){
    // auth.hideHeader(true);
  },
  computed:{
  },
  methods: {
    iframe_url: function(){
      var self=this;

      self.check_rec().then(function(res){
        if(res.data.length==0){
          var url = [
            comm.form_ip,
            self.form_id,
            "&username=",
            self.username,
						"&name=",
						self.name,
            "&hub=",
            self.hub,
            "&department=",
            self.department,
            // "&year=",
            // self.selected.year,
            // "&quarter=",
            // self.selected.quarter
          ];
          self.selected.iframe.url=url.join("");
          self.show_form = true;
        } else {
          var msg = [
            "Your have performed the survey. Thank You."
          ];
          common.wMsgBox.Error(msg.join(""));
          self.selected.iframe.url="";
        }
      });
      
    },
    check_rec: function(){
      var check = [
        "for rec in form_datas ",
        "filter contains(rec.form_id,'",
        this.form_id,
        "') && contains(rec.submission.data.username,'",
        this.username,
        // "') && contains(rec.submission.data.year,'",
        // this.selected.year,
        // "') && contains(rec.submission.data.quarter,'",
        // this.selected.quarter,
        "') return 1"
      ]
      check = check.join("");
      return comm.getFormData(check);
    },

  },
  // watch:{
  //   "selected.appraisee":function(old,new1 ){
  //     debugger;
  //   }
  // },
  mounted: async function() {
    // var pageID = common.App.get_pageID();
    var pageUUID = common.App.get_pageUUID();
		var temp = auth.getMenu().concat(auth.getMenu_int());
		for (var h in temp) {
			// if (temp[h].id == pageID) {
      if (temp[h].uuid == pageUUID) {
				this.form_id = temp[h].component_path.form_id;
				this.display_text = temp[h].display_text;
				this.return_page = temp[h].component_path.returnPage_path;
			}
		}

    this.username = auth.getUsername();
		this.name = auth.getFullName();
    this.hub = auth.getHub();

    // get user's department
    let cls_qb = new qb.QueryBuilder();
    cls_qb.Method = "all";
    cls_qb.Table = "emps_dept_employee";
    cls_qb.Select = ["dept__name"];
    var rule = new qb.Rule();
    rule
      .field("emp__user__username")
      .operator(qb.STR_OPERATOR.EQUAL)
      .value(this.username);
    cls_qb.addRule(rule);
    // cls_qb.Order = ["full_name"];
    let result = await common.wBackEndComm.PostData("process_qb/", cls_qb);
    if (result.data.Status == 1) {
      if (result.data.Body.records.length > 0) {
        this.department = result.data.Body.records[0].dept__name;
      } else {
        common.wMsgBox.Info(
          "Contact administrator for department configuration."
        );
      }
    } else {
      common.wMsgBox.Error(result.data.Description);
    }

    // NOTE: call for year listing
    // var years = await comm.getFormData(
    //   'for rec in setting_year filter rec.status == 1 sort rec.order asc return {"id":rec._id, "name":rec.name, "description": rec.description, "order":rec.order}'
    // );
    // this.years = years.data;

    // NOTE: call for quarter listing
    // var quarters = await comm.getFormData(
    //   'for rec in setting_quater filter rec.status == 1 sort rec.order asc return {"id":rec._id, "name":rec.name, "description": rec.description, "order":rec.order}'
    // );
    // this.quarters = quarters.data;

    var self = this;
    function handleMessage(e) {
      if (e.data.event == "form_data_saved") {
        common.wMsgBox.Success("Record successfully submitted.");
				// self.selected.iframe.height = e.data.window.height;
        // self.$router.push({path: self.return_page}); ********** ori
        window.location.href = self.return_page;
      }
      if (e.data.event == "form_loaded") {
        self.selected.iframe.height = e.data.window.height + 350;
      }
    }

    window.addEventListener("message", handleMessage, false);

		this.show_form = this.iframe_url();

  }
};
</script>

<style>
</style>
